import React from 'react';
import { ElementBreadCrumb } from '../../../shared/Components/ElementBreadCrumb';
import { EntityLanguage } from '../../../shared/Domain/EntityLanguage';
import { EntityMenu } from '../../../shared/Domain/EntityMenu';
import './Style.scss';

interface ContainerProps {
    listMenu: EntityMenu[];
    onClickMenu(row: EntityMenu): void;
    languageTranslate: EntityLanguage;
    WorkflowPending: any;
}

const iconColors = ['#E8622C', '#0B2A5B', '#0E9F86', '#4C6FFF', '#8B5CF6'];

export const ViewMain = (props: ContainerProps) => {
    return (
        <div className="ViewMainApprovals">
            <div className="container-fluid">
                <ElementBreadCrumb list={props.languageTranslate.moduloApprovals.navBar} title={props.languageTranslate.moduloApprovals.textoTitulo} />
                <div className="container-items-approvals">
                    {
                        props.listMenu
                            .filter(row => !!props.WorkflowPending[row.sigla])
                            .map((row, index) => (
                                <div className="items-approvals" key={row.id}>
                                    <div className='CardApproval shadow-sm' onClick={() => props.onClickMenu(row)}>
                                        <div className='CardApproval-icon' style={{ backgroundColor: iconColors[index % iconColors.length] }}>
                                            <i className={`text-white ${row.icono}`} />
                                        </div>
                                        <span className='CardApproval-badge shadow-sm'>{props.WorkflowPending[row.sigla]}</span>
                                        <span className='CardApproval-title'>{props.languageTranslate.menu[row.codigo as keyof typeof props.languageTranslate.menu]?.titulo}</span>
                                    </div>
                                </div>
                            ))
                    }
                </div>
            </div>
        </div>
    )
}